/**
 * Cuánto puede desviarse el arqueo antes de que sea una diferencia de verdad.
 *
 * La regla estaba escrita tres veces y sólo una de ellas era la buena. El
 * formulario del cierre calculaba `max(0,01 , margen del TPV)` para decidir si
 * pedía autorización de un supervisor; el listado y el ticket, en cambio,
 * pintaban la diferencia de rojo con un `0.01` literal, **sin mirar el margen**.
 * Un cierre que quedó dentro de su margen y se autorizó sin problema salía en
 * rojo igual, y nadie podía saber si eso era grave o no.
 *
 * El `0,01` no es un margen de negocio: es un piso técnico. Está para que a
 * cinco decimales --Costa Rica-- la unidad menor no sea `0,00001` y una caja
 * cuadrada dispare autorización por puro ruido de redondeo.
 */

/** El piso técnico, por debajo del cual todo es ruido de redondeo. */
export const TOLERANCIA_DE_REDONDEO = 0.01;

/**
 * El margen que aplica a un TPV: el suyo, o el piso técnico si no llega a él.
 *
 * @param {{margenCierre?: number|string}} [tpv] La ficha del TPV.
 */
export const margenDelArqueo = (tpv) => {
  const configurado = parseFloat(tpv?.margenCierre) || 0;

  return Math.max(TOLERANCIA_DE_REDONDEO, configurado);
};

/**
 * ¿Esta diferencia está dentro de lo admitido?
 *
 * Sin ficha de TPV se aplica el piso, que es lo que hacían el listado y el
 * ticket: no es lo ideal, pero no cambia lo que ya mostraban.
 *
 * @param {number} diferencia Lo digitado menos lo cobrado.
 * @param {{margenCierre?: number|string}} [tpv] La ficha del TPV.
 */
export const diferenciaAceptable = (diferencia, tpv) =>
  Math.abs(Number(diferencia) || 0) <= margenDelArqueo(tpv);
